import { Policy } from '@summit/core';
import { EboRoles } from './ebo-roles.enum';

export enum EboPermissions {
  //Moving to claims (2nd section)
  PermissionsAny = EboRoles.SysAdmin |
    EboRoles.Admin |
    EboRoles.BackOffice |
    EboRoles.Payroll |
    EboRoles.Manager |
    EboRoles.Mechanic |
    EboRoles.LeadDriver,
  PermissionsManager = EboRoles.SysAdmin | EboRoles.Admin | EboRoles.BackOffice | EboRoles.Manager,
  PermissionsBackOffice = EboRoles.SysAdmin | EboRoles.Admin | EboRoles.BackOffice,
  PermissionsPayroll = EboRoles.SysAdmin | EboRoles.Admin | EboRoles.Payroll,
  PermissionsAdmin = EboRoles.SysAdmin | EboRoles.Admin,
  PermissionsLeadDriver = EboRoles.SysAdmin |
    EboRoles.Admin |
    EboRoles.BackOffice |
    EboRoles.Payroll |
    EboRoles.Manager |
    EboRoles.Mechanic,
  PermissionsMechanic = EboRoles.SysAdmin |
    EboRoles.Admin |
    EboRoles.BackOffice |
    EboRoles.Payroll |
    EboRoles.Manager |
    EboRoles.Mechanic,
  PermissionsDispatch = EboRoles.SysAdmin | EboRoles.Admin | EboRoles.BackOffice | EboRoles.Payroll | EboRoles.Dispatch,
  PermissionsSysAdmin = EboRoles.SysAdmin,

  //Claims
  PermissionsTruck = EboRoles.SysAdmin | EboRoles.Admin | EboRoles.BackOffice | EboRoles.Manager | EboRoles.Mechanic,
  PermissionsSchedule = EboRoles.SysAdmin |
    EboRoles.Admin |
    EboRoles.BackOffice |
    EboRoles.Manager |
    EboRoles.LeadDriver |
    EboRoles.Mechanic |
    EboRoles.Dispatch,
  PermissionsRoute = EboRoles.SysAdmin | EboRoles.Admin | EboRoles.BackOffice | EboRoles.Manager
}

export const PolicyToPermissionsMapping: Record<Policy, EboPermissions> = {
  [Policy.Any]: EboPermissions.PermissionsAny,
  [Policy.Manager]: EboPermissions.PermissionsManager,
  [Policy.BackOffice]: EboPermissions.PermissionsBackOffice,
  [Policy.Payroll]: EboPermissions.PermissionsPayroll,
  [Policy.Admin]: EboPermissions.PermissionsAdmin,
  [Policy.SysAdmin]: EboPermissions.PermissionsSysAdmin,
  [Policy.LeadDriver]: EboPermissions.PermissionsLeadDriver,
  [Policy.Mechanic]: EboPermissions.PermissionsMechanic,
  //Use the ones below for claims
  [Policy.TruckPermissions]: EboPermissions.PermissionsTruck,
  [Policy.SchedulePermissions]: EboPermissions.PermissionsSchedule,
  [Policy.RoutePermissions]: EboPermissions.PermissionsRoute,
  [Policy.EmployeePermissions]: EboPermissions.PermissionsAny
};

export const RoleToPermissionsMapping: Record<EboRoles, EboPermissions> = {
  [EboRoles.None]: EboPermissions.PermissionsAny,
  [EboRoles.Manager]: EboPermissions.PermissionsManager,
  [EboRoles.BackOffice]: EboPermissions.PermissionsBackOffice,
  [EboRoles.Payroll]: EboPermissions.PermissionsPayroll,
  [EboRoles.Admin]: EboPermissions.PermissionsAdmin,
  [EboRoles.SysAdmin]: EboPermissions.PermissionsSysAdmin,
  [EboRoles.Mechanic]: EboPermissions.PermissionsMechanic,
  [EboRoles.LeadDriver]: EboPermissions.PermissionsLeadDriver,
  [EboRoles.Dispatch]: EboPermissions.PermissionsSchedule // Dispatch has the same permissions as any other role
};
